import React, { useEffect, useState } from "react";
import { Table, Input, Tag, Form, Button, Space, Modal, Spin, Descriptions, Card, Popconfirm, message, Checkbox, Select, Tooltip, Dropdown, DatePicker, Radio } from "antd";
import { Helmet } from "react-helmet";
import { Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import RequirePermission from "../components/Common/RequirePermission";
import LocationFilter from "../components/Common/LocationFilter";
import CityFilter from "../components/Common/CityFilter";
import {
  EyeOutlined,
  DeleteOutlined,
  CloseOutlined,
  DownOutlined,
  DisconnectOutlined,
  ExclamationCircleOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import DeviceForm from "../components/Devices/DeviceForm";

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const obj = {
  0: "Landscape Primary",
  180: "Landscape Secondary",
  90: "Portrait Primary",
  270: "Portrait Secondary"
};

const Devices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [user, setUser] = useState(null);
  const [detail, setDetail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editingDevice, setEditingDevice] = useState(null);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [playlists, setPlaylists] = useState([]);
  const [screens, setScreens] = useState([]);
  const [locations, setLocations] = useState([]);
  const [cities, setCities] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [assignScreenModalOpen, setAssignScreenModalOpen] = useState(false);
  const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [currentScreen, setCurrentScreen] = useState(null);
  const [assignPlaylistModalOpen, setAssignPlaylistModalOpen] = useState(false);
  const [assignScreenSingleModalOpen, setAssignScreenSingleModalOpen] = useState(false);
  const [screenOptions, setScreenOptions] = useState([]);
  const [screenSearch, setScreenSearch] = useState("");
  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [totalLogRecords, setTotalLogRecords] = useState(0);
  const [logPageSize, setLogPageSize] = useState(10);
  const [logCurrentPage, setLogCurrentPage] = useState(1);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [eventFilter, setEventFilter] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [statusSearch, setStatusSearch] = useState("");
  const [connectedSearch, setConnectedSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [isForceOrientation, setIsForceOrientation] = useState("");
  const [isForceOrientationPosition, setIsForceOrientationPosition] = useState(null);

  const device_logs = "Device Logs";
  const setQueryParams = (params) => {
    const searchParams = new URLSearchParams(params);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    const newQueryParams = {
      status: statusSearch || "",
      connected: connectedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      filter: value,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleScreenChange = (value) => {
    setScreenSearch(value || "");
    const newQueryParams = {
      status: statusSearch || "",
      connected: connectedSearch || "",
      screen: value,
      city: citySearch || "",
      location: locationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleStatusChange = (value) => {
    setStatusSearch(value || "");
    const newQueryParams = {
      status: value,
      connected: connectedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleConnectedChange = (value) => {
    setConnectedSearch(value || "");
    const newQueryParams = {
      status: statusSearch || "",
      connected: value,
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleCityChange = (value) => {
    setCitySearch(value || "");
    const filteredLocations = locations
      .filter((location) => location.city_id === value)
      .map((location) => ({
        id: location.id,
        name: location.name,
      }));
    if (filteredLocations.length === 0) {
      setLocationOptions(locations);
    }
    else {
      setLocationOptions(filteredLocations);
    }
    const newQueryParams = {
      status: statusSearch || "",
      connected: connectedSearch || "",
      screen: screenSearch || "",
      city: value,
      location: locationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleLocationChange = (value) => {
    if (value === "") {
      message.warning("Please select a city first.");
    }
    setLocationSearch(value || "");
    const newQueryParams = {
      status: statusSearch || "",
      connected: connectedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: value,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleLogTableChange = (pagination) => {
    const { current, pageSize } = pagination;

    // Update state
    setLogCurrentPage(current);
    setLogPageSize(pageSize);

    // Fetch data with new pagination
    if (selectedDeviceId) {
      fetchLogs(selectedDeviceId, current, pageSize);
    }
  };

  const handleForceOrientationChange = (e) => {
    const value = e.target.value;
    setIsForceOrientation(value);
    if (value === "no") {
      setIsForceOrientationPosition(null);
    }
  };

  const handleForceOrientationPositionChange = (value) => {
    setIsForceOrientationPosition(value);
  };

  const handleSelectAllChecked = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    const checked = e.target.checked;
    const newSelectedDevices = {};
    devices.forEach((device) => {
      newSelectedDevices[device.id] = checked;
    });

    setSelectedDevices(newSelectedDevices);
    setIsSelectAllChecked(checked);
  };

  const handleSingleCheckboxChange = (e, deviceId) => {
    e.stopPropagation(); // Prevent event bubbling
    const newSelectedDevices = {
      ...selectedDevices,
      [deviceId]: e.target.checked,
    };
    setSelectedDevices(newSelectedDevices);
    // Check if all checkboxes are selected (only count devices that exist)
    const totalDevices = devices.length;
    const selectedCount = Object.values(newSelectedDevices).filter(Boolean).length;
    const allSelected = totalDevices > 0 && selectedCount === totalDevices;
    setIsSelectAllChecked(allSelected);
  };

  const handleEdit = (record) => {
    setIsModalOpen(true);
    setEditingDevice(record);
  };

  const handleAssign = (record) => {
    setAssignPlaylistModalOpen(true);
    setSelectedPlaylist(record.playlist_id || null);
    setCurrentPlaylist(record.playlist_id || null);
    setSelectedDevice([record.id]);
  };

  const handleScreen = (record) => {
    setAssignScreenSingleModalOpen(true);
    setSelectedScreen(record.screen_id || null);
    setCurrentScreen(record.screen_id || null);
    setSelectedDevice([record.id]);
  }

  const handleDelete = async (record) => {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BASE_URL + `/api/devices/${record.id}`
      );
      const updated_row_count = response.data.data.updated_row_count;
      await fetchData();
      if (updated_row_count === 1) {
        message.success("Screen deleted");
      }
    } catch (error) {
      console.error("Error deleting screen", error);
    }
  };

  const handleView = async (record) => {
    try {
      setLoading(true);
      setIsViewModalOpen(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices/${record.id}`
      );
      setDetail(response.data.data);
      setIsForceOrientation(record.is_force_orientation===null ? "no" : record.is_force_orientation);
      setIsForceOrientationPosition(record.force_orientation_position);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching screen data", error);
    }
  };

  const handleOpenMap = async (lat, lng) => {
    try {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      window.open(url, "_blank");
    } catch (error) {
      message.error("Error opening map");
      console.error("Error fetching screen data", error);
    }
  };

  const handleLogs = async (record) => {
    try {
      setLoading(true);
      setLogsModalOpen(true);
      setSelectedDeviceId(record.id);
      await fetchLogs(record.id, logCurrentPage, logPageSize);
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      console.error("Error fetching screen data", error);
    }
  };

  const fetchLogs = async (deviceId, page = logCurrentPage, limit = logPageSize) => {
    try {
      setLoading(true);
      const params = {
        limit,
        page,
      };

      if (eventFilter) {
        params.event = eventFilter;
      }

      if (dateRange.length === 2) {
        params.startDate = dateRange[0].format("YYYY-MM-DD");
        params.endDate = dateRange[1].format("YYYY-MM-DD");
      }

      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices/${deviceId}/logs`,
        { params }
      );

      let records = response.data.data.data;
      setTotalLogRecords(response.data.data.total);
      setLogs(records);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching logs data", error);
    }
  };


  const handleDisconnect = async (record) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/api/disconnect`,
        {
          device_ids: [record.id],
        }
      )
      const { updated_row_count, message: responseMessage } = response.data.data;

      await fetchData();
      if (updated_row_count === 1) {
        message.success("Device disconnected successfully");
      } else {
        message.warning(responseMessage);
      }
    } catch (error) {
      console.error("Error disconnecting device", error);
      message.error("Failed to disconnect device");
    }
  };

  const fetchMasterData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/devices/masters`
      );
      const playlistData = response.data.data.playlists;
      const screenData = response.data.data.screens;
      setPlaylists(playlistData);
      setScreens(screenData);
      setScreenOptions(screenData.map((screen) => {
        return {
          value: screen.id,
          label: screen.name
        };
      }));
      if (
        queryParams.get("screen") &&
        queryParams.get("screen") !== "" &&
        !isNaN(queryParams.get("screen"))
      ) {
        setScreenSearch(parseInt(queryParams.get("screen")));
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch master data", error);
      setLoading(false);
    }
  };

  const handleAssignPlaylist = async () => {
    if (!selectedPlaylist) {
      message.error("Please select a playlist");
      return;
    }

    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id]
    );

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-playlist`,
        {
          device_ids: selectedDeviceIds,
          playlist_id: selectedPlaylist,
        }
      );
      message.success("Playlist assigned successfully");
      setAssignModalOpen(false);
      setSelectedPlaylist(null);
      setCurrentPlaylist(null);
      await fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign playlist", error);
      message.error("Failed to assign playlist");
    }
  };

  const handleAssignSinglePlaylist = async () => {
    if (!selectedPlaylist) {
      message.error("Please select a playlist");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-playlist`,
        {
          device_ids: selectedDevice,
          playlist_id: selectedPlaylist,
        }
      )
      message.success("Playlist assigned successfully");
      setAssignPlaylistModalOpen(false);
      setSelectedPlaylist(null);
      setCurrentPlaylist(null);
      await fetchData(); // Refresh playlist list
    }
    catch (error) {
      console.error("Failed to assign playlist", error);
      message.error("Failed to assign playlist");
    }
  };

  const handleAssignScreen = async () => {
    if (!selectedScreen) {
      message.error("Please select a screen");
      return;
    }

    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id]
    );

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-screen`,
        {
          device_ids: selectedDeviceIds,
          screen_id: selectedScreen,
        }
      )
      message.success("Screen assigned successfully");
      setAssignScreenModalOpen(false);
      setSelectedScreen(null);
      setCurrentScreen(null);
      await fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign screen", error);
      message.error("Failed to assign screen");
    }
  };

  const handleAssignSingleScreen = async () => {
    if (!selectedScreen) {
      message.error("Please select a screen");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-screen`,
        {
          device_ids: selectedDevice,
          screen_id: selectedScreen,
        }
      )
      message.success("Screen assigned successfully");
      setAssignScreenSingleModalOpen(false);
      setSelectedScreen(null);
      setCurrentScreen(null);
      await fetchData(); // Refresh screen list
    }
    catch (error) {
      console.error("Failed to assign screen", error);
      message.error("Failed to assign screen");
    }
  };

  const handleAssignDisconnect = async () => {
    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id]
    );

    if (selectedDeviceIds.length === 0) {
      message.warning("No devices selected for disconnection");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/disconnect`,
        {
          device_ids: selectedDeviceIds,
        }
      )
      const {
        updated_row_count,
        message: responseMessage
      } = response.data.data;

      await fetchData();
      if (updated_row_count > 0) {
        message.success(
          `${updated_row_count} device(s) disconnected successfully.`
        );
      }
      else {
        message.warning(responseMessage);
      }
    }
    catch (error) {
      console.error("Failed to disconnect device", error);
      message.error("Failed to disconnect device");
    }
  };

  const handleRemovePlaylist = async (record) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/remove-playlist/${record.id}`,
      );
      message.success("Playlist unassigned successfully");
      setSelectedPlaylist(null);
      await fetchData(); // Refresh playlist list
    }
    catch (error) {
      console.error("Failed to remove playlist", error);
      message.error("Failed to remove playlist");
    }
  };

  const handleRemoveScreen = async (record) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/remove-screen/${record.id}`,
      );
      message.success("Screen unassigned successfully");
      setSelectedScreen(null);
      await fetchData(); // Refresh screen list
    }
    catch (error) {
      console.error("Failed to remove screen", error);
      message.error("Failed to remove screen");
    }
  };

  const handelViewSubmit = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/updateOrientation`,
        {
          id,
          force_orientation: isForceOrientation===null ? "no" : isForceOrientation,
          force_orientation_position: isForceOrientation === "yes"
            ? parseInt(isForceOrientationPosition)
            : null,
        }
      );

      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 0) {
        message.info("No changes made");
      } else if (updated_row_count === 1) {
        message.success("Device updated");
        await fetchData();
      } else {
        message.error("Error updating device");
      }
    } catch (error) {
      console.error("Error updating device", error);
      message.error("Error updating device");
    }
  };


  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
            screen: screenSearch,
            status: statusSearch,
            connected: connectedSearch,
            city: citySearch,
            location: locationSearch
          },
        }
      );
      let records = response.data.data.data;
      setTotalRecords(response.data.data.total);
      setDevices(records);
      const location = JSON.parse(localStorage.getItem('locations'));
      let city = [];
      for (let i = 0; i < location.length; i++) {
        city.push({
          id: location[i].city_id,
          name: location[i].city_name
        })
      }
      const uniqueCities = Array.from(
        new Map(city.map((item) => [item.id, item])).values()
      );
      setLocations(location);
      setCities(uniqueCities);
      if (!citySearch) {
        setLocationOptions(location);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching locations data", error);
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setViewPermission(parseInt(permissions["signage.screens_view"]) === 1);
    setEditPermission(parseInt(permissions["signage.screens_edit"]) === 1);
    setDeletePermission(parseInt(permissions["signage.screens_delete"]) === 1);
  }, []);

  useEffect(() => {
      fetchMasterData();
  }, [assignModalOpen, assignScreenModalOpen, assignScreenSingleModalOpen, assignPlaylistModalOpen]);

  useEffect(() => {
    if (selectedDeviceId && logsModalOpen) {
      fetchLogs(selectedDeviceId, logCurrentPage, logPageSize);
    }
  }, [logCurrentPage, logPageSize]);

  useEffect(() => {
    const newQueryParams = {
      status: statusSearch,
      connected: connectedSearch,
      city: citySearch,
      location: locationSearch,
      screen: screenSearch,
      filter: filterText,
      limit: queryParams.get("limit") ?? 10,
      page: queryParams.get("page") ?? 1,
    };

    // Only navigate if something really changed
    if (JSON.stringify(newQueryParams) !== JSON.stringify(Object.fromEntries(new URLSearchParams(location.search)))) {
      setQueryParams(newQueryParams);
    }

    setQueryParams(newQueryParams);
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, pageSize, filterText, screenSearch, statusSearch, connectedSearch, citySearch, locationSearch]);

  const columns = [
    (editPermission ? {
      title: (
        <Checkbox
          name="selected_device"
          onClick={(e) => handleSelectAllChecked(e)}
          checked={isSelectAllChecked}
        />
      ),
      dataIndex: "id",
      render: (text, record) => ( // As ant design render function includes like (text,record,index).
        <Checkbox
          name="selected_device"
          value={record.id}
          onChange={(e) => handleSingleCheckboxChange(e, record.id, record.screen_id)}
          checked={selectedDevices[record.id] || false}
          onClick={(e) => e.stopPropagation()}
        />
      )
    } : []),
    {
      title: "Unique ID",
      dataIndex: "uuid",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Model",
      dataIndex: "model_name",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Platform",
      dataIndex: "platform_name",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Orientation",
      dataIndex: "orientation",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: "Force Orientation",
      dataIndex: "is_force_orientation",
      render: (text, record) => <>
        {text ? <Tag size="small" color={text === "yes" ? "green" : "red"}>{text}</Tag>: <Tag size="small" color="red">no</Tag>}
        <br></br>
        {record.is_force_orientation === "yes" && (<span className="text-small">
          {record.force_orientation_position === 270 ? "Portrait Secondary" : record.force_orientation_position === 180 ? "Landscape Secondary" : record.force_orientation_position === 90 ? "Portrait Primary" : "Landscape Primary"}
        </span>)}
      </>,
    },
    {
      title: "Screen",
      dataIndex: "screen_name",
      render: (Name, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              size="small"
              type="text"
              style={{ backgroundColor: "transparent", color: Name ? 'green' : 'red', padding: 0 }}
              onClick={() => handleScreen(record)}
            ><Tag color={Name ? "green" : "red"}>
                {Name ? Name : "Screen not connected"}
              </Tag>
            </Button>
          </Tooltip>
          {record.screen_name && <Popconfirm
            title="Are you sure to unassign this screen?"
            onConfirm={() => handleRemoveScreen(record)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Unassign Screen">
              <Button
                size="small"
                danger
                style={{ fontSize: 10 }}
              >
                <CloseOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>}
        </>
      ),
    },
    {
      title: "Playlist",
      dataIndex: "playlist_title",
      render: (playlist_title, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              size="small"
              type="text"
              style={{ backgroundColor: "transparent", color: playlist_title ? 'green' : 'red', padding: 0 }}
              onClick={() => handleAssign(record)}
            ><Tag color={playlist_title ? "green" : "red"}>
                {playlist_title ? playlist_title : "Playlist not assigned"}
              </Tag>
            </Button>
          </Tooltip>
          {record.playlist_title && <Popconfirm
            title="Are you sure to unassign this playlist?"
            onConfirm={() => handleRemovePlaylist(record)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Unassign Playlist">
              <Button
                size="small"
                danger
                style={{ fontSize: 10 }}
              >
                <CloseOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>}
        </>
      ),
    },
    {
      title: "Device Status",
      dataIndex: "status",
      render: (status, record) => (
        <Tooltip title="Edit">
          <Button
            size="small"
            type="text"
            style={{ backgroundColor: "transparent", color: status === "active" ? 'green' : 'red' }}
            onClick={() => handleEdit(record)}
          ><Tag color={status === "active" ? "green" : "red"}>{status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}</Tag>
          </Button>
        </Tooltip>
      )
    },
    {
      title: "Connection Status",
      dataIndex: "screen_connection_status",
      render: (status, record) => (
        <>
          {status ? (
            status === "connected" ? (
              <>
                <Tag color="green">Connected</Tag>
                {record.last_connected_at && (
                  <span className="text-small">
                    <br />
                    {dayjs(record.last_connected_at).format("DD-MM-YYYY HH:mm")}
                  </span>
                )}
              </>
            ) : (
              <>
                <Tag color="red">Disconnected</Tag>
                {record.last_disconnected_at && (
                  <span className="text-small">
                    <br />
                    {dayjs(record.last_disconnected_at).format("DD-MM-YYYY HH:mm")}
                  </span>
                )}
              </>
            )
          ) : (
            <Tag color="blue">Init</Tag>
          )}
        </>

      )
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      render: (text) => (
        <span className="text-small">
          {text ? dayjs(text).format("DD-MM-YYYY HH:mm") : "Not Updated"}
        </span>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user && (
            <>
              {viewPermission && (
                <Tooltip title="View">
                  <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => handleView(record)}
                  />
                </Tooltip>
              )}
              {viewPermission && (
                <Tooltip title="Logs">
                  <Button
                    size="small"
                    icon={<DatabaseOutlined />}
                    onClick={() => handleLogs(record)}
                  />
                </Tooltip>
              )}
              {editPermission && (
                <Popconfirm
                  title="Are you sure to disconnect this device?"
                  onConfirm={() => handleDisconnect(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Disconnect">
                    <Button
                      size="small"
                      type="primary"
                      icon={<DisconnectOutlined />}
                      disabled={record.screen_connection_status === "connected" ? false : true}
                    />
                  </Tooltip>
                </Popconfirm>
              )}
              {deletePermission && (
                <Popconfirm
                  title="Are you sure to delete this device?"
                  onConfirm={() => handleDelete(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Delete">
                    <Button
                      size="small"
                      danger
                      icon={<DeleteOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              )}
            </>
          )}
        </Space>
      ),
    }
  ];

  const columnLogs = [
    {
      title: "Screen Name",
      dataIndex: "name",
      key: "name",
      render: (name) => (
        <Tag color={name ? "green" : "red"}>{name ? name : "Screen not assigned"}</Tag>
      )
    },
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
      render: (event) => (
        <Tag color={event === "init" ? "blue" : event === "connected" ? "green" : "red"}>
          {event.charAt(0).toUpperCase() + event.slice(1).toLowerCase()}
        </Tag>),
    },
    {
      title: "Event Time",
      dataIndex: "event_time",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      )
    },
  ];

  return (
    <RequirePermission permission="signage.screens_view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Devices`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Devices
        </Title>
        <div className="d-sm-block d-md-flex justify-content-between mb-3">
          <div>
            <Form layout="inline">
              <Form.Item>
                <Dropdown
                  trigger={['click']}
                  onClick={(e) => e.preventDefault()}
                  menu={{
                    items: [
                      {
                        key: 'assign-playlist',
                        label: 'Assign Playlist',
                        disabled: Object.values(selectedDevices).filter(Boolean).length === 0,
                        onClick: () => setAssignModalOpen(true),
                      },
                      {
                        key: 'assign-screen',
                        label: 'Assign Screen',
                        disabled: Object.values(selectedDevices).filter(Boolean).length === 0,
                        onClick: () => setAssignScreenModalOpen(true),
                      },
                      {
                        key: 'assign-disconnect',
                        label: 'Disconnect Device',
                        disabled: Object.values(selectedDevices).filter(Boolean).length === 0,
                        onClick: () => {
                          Modal.confirm({
                            title: 'Confirm Disconnect',
                            icon: <ExclamationCircleOutlined />,
                            content: 'Are you sure you want to disconnect the selected devices?',
                            okText: 'Yes, Disconnect',
                            okType: 'danger',
                            cancelText: 'Cancel',
                            onOk() {
                              handleAssignDisconnect();
                            },
                            onCancel() {
                              console.log('Disconnect operation cancelled');
                            },
                          });
                        }
                      }
                    ],
                  }}
                  disabled={Object.values(selectedDevices).filter(Boolean).length === 0}
                >
                  <Button type="primary">
                    <Space>
                      Actions
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Form.Item>
              <Form.Item>
                <Input.Search
                  placeholder="Search Device"
                  value={filterText}
                  className="me-1"
                  onChange={handleSearch}
                  style={{ width: 200 }}
                />
              </Form.Item>
              <Form.Item label="Screen">
                <Select
                  value={screenSearch}
                  onChange={(e) => handleScreenChange(e)}
                  onClick={async ()=> {await fetchMasterData();}}
                  style={{ width: 150 }}
                  showSearch
                  filterOption={(input, option) => {
                    // Fix 5: Better filter logic
                    return (option?.label ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  allowClear
                  options={screenOptions}
                >
                </Select>
              </Form.Item>
              <Form.Item label="Status">
                <Select
                  value={statusSearch}
                  onChange={(e) => handleStatusChange(e)}
                  style={{ width: 150 }}
                  showSearch
                  filterOption={(input, option) => {
                    // Fix 5: Better filter logic
                    return (option?.children ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  allowClear
                >
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                </Select>
              </Form.Item>
              <Form.Item label="Connection Status">
                <Select
                  value={connectedSearch}
                  onChange={(e) => handleConnectedChange(e)}
                  style={{ width: 150 }}
                  showSearch
                  filterOption={(input, option) => {
                    // Fix 5: Better filter logic
                    return (option?.children ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  allowClear
                >
                  <Option value="connected">Connected</Option>
                  <Option value="disconnected">Disconnected</Option>
                  <Option value="null">Init</Option>
                </Select>
              </Form.Item>
              <Form.Item label="City" style={{ marginTop: window.innerWidth < 1600 ? "1rem" : "0" }}>
                <CityFilter cities={cities} citySearch={citySearch} handleCityChange={handleCityChange} />
              </Form.Item>
              <Form.Item label="Location" style={{ marginTop: window.innerWidth < 1600 ? "1rem" : "0" }}>
                <LocationFilter locationOptions={locationOptions} locationSearch={locationSearch} handleLocationChange={handleLocationChange} />
              </Form.Item>
            </Form>
          </div>
        </div>

        <Table
          loading={loading}
          columns={columns}
          dataSource={devices}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} devices`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
        {isModalOpen && (
          <DeviceForm
            isModalOpen={isModalOpen}
            editingScreen={editingDevice}
            closeModal={() => setIsModalOpen(false)}
            handleUpdateList={fetchData}
          />
        )}
        <Modal
          title="Assign Playlist"
          open={assignModalOpen}
          onCancel={() => {
            setAssignModalOpen(false);
            setSelectedPlaylist(null);
            setCurrentPlaylist(null);
          }}
          width={{
            xs: '80%',
            sm: '70%',
            md: '60%',
            lg: '50%',
            xl: '40%',
            xxl: '30%',
          }}
          maskClosable={false}
          onOk={() => {
            handleAssignPlaylist();
          }}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedPlaylist || selectedPlaylist === currentPlaylist,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Playlist"
            value={selectedPlaylist}
            onChange={(value) => setSelectedPlaylist(value)}
          >
            {playlists.map((playlist) => (
              <Select.Option key={playlist.id} value={playlist.id}>
                {playlist.title}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Playlist"
          open={assignPlaylistModalOpen}
          onCancel={() => {
            setAssignPlaylistModalOpen(false);
            setSelectedPlaylist(null);
            setCurrentPlaylist(null);
          }}
          width={{
            xs: '80%',
            sm: '70%',
            md: '60%',
            lg: '50%',
            xl: '40%',
            xxl: '30%',
          }}
          maskClosable={false}
          onOk={handleAssignSinglePlaylist}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedPlaylist || selectedPlaylist === currentPlaylist,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Playlist"
            value={selectedPlaylist}
            onChange={(value) => setSelectedPlaylist(value)}
          >
            {playlists.map((playlist) => (
              <Select.Option key={playlist.id} value={playlist.id}>
                {playlist.title}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Screen"
          open={assignScreenModalOpen}
          onCancel={() => {
            setAssignScreenModalOpen(false);
            setSelectedScreen(null);
            setCurrentScreen(null);
          }}
          width={{
            xs: '80%',
            sm: '70%',
            md: '60%',
            lg: '50%',
            xl: '40%',
            xxl: '30%',
          }}
          maskClosable={false}
          onOk={() => {
            handleAssignScreen();
          }}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedScreen || selectedScreen === currentScreen,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Screen"
            value={selectedScreen}
            onChange={(value) => setSelectedScreen(value)}
          >
            {screens.map((screen) => (
              <Select.Option key={screen.id} value={screen.id}>
                {screen.name}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Screen"
          open={assignScreenSingleModalOpen}
          onCancel={() => {
            setAssignScreenSingleModalOpen(false);
            setSelectedScreen(null);
            setCurrentScreen(null);
          }}
          width={{
            xs: '80%',
            sm: '70%',
            md: '60%',
            lg: '50%',
            xl: '40%',
            xxl: '30%',
          }}
          maskClosable={false}
          onOk={handleAssignSingleScreen}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedScreen || selectedScreen === currentScreen,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Screen"
            value={selectedScreen}
            onChange={(value) => setSelectedScreen(value)}
          >
            {screens.map((screen) => (
              <Select.Option key={screen.id} value={screen.id}>
                {screen.name}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="View Device"
          open={isViewModalOpen}
          onCancel={() => {
            setIsViewModalOpen(false);
          }}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
          footer={null}
        >
          {
            loading ? <Spin /> : detail && (
              <form onSubmit={(e) => { handelViewSubmit(detail.id); e.preventDefault(); setIsViewModalOpen(false); }} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }} onReset={() => {handelViewSubmit(detail.id); setIsViewModalOpen(false)}}>
                <Descriptions bordered column={1} size="small">
                  <Descriptions.Item label="ID">{detail.uuid.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item label="Name">{detail.type}</Descriptions.Item>
                  <Descriptions.Item label="Tizen ID">{detail.tizen_id}</Descriptions.Item>
                  <Descriptions.Item label="Platform">{detail.platform_name}</Descriptions.Item>
                  <Descriptions.Item label="Processor">{detail.platform_processor}</Descriptions.Item>
                  <Descriptions.Item label="Model">{detail.model_name}</Descriptions.Item>
                  <Descriptions.Item label="Network Push">{detail.network_push}</Descriptions.Item>
                  <Descriptions.Item label="Build Date">{detail.build_date}</Descriptions.Item>
                  <Descriptions.Item label="Build String">{detail.build_string}</Descriptions.Item>
                  <Descriptions.Item label="Manufacturer">{detail.manufacturer.charAt(0).toUpperCase() + detail.manufacturer.slice(1)}</Descriptions.Item>
                  <Descriptions.Item label="Build ID">{detail.build_id}</Descriptions.Item>
                  <Descriptions.Item label="Firmware API">{detail.firmware_api}</Descriptions.Item>
                  <Descriptions.Item label="Resolution">{`${detail.resolution_width} × ${detail.resolution_height}`}</Descriptions.Item>
                  <Descriptions.Item label="Screen Size">{`${detail.physical_width} × ${detail.physical_height}`}</Descriptions.Item>
                  <Descriptions.Item label="DPI">{`${detail.dpi_width} × ${detail.dpi_height}`}</Descriptions.Item>
                  <Descriptions.Item label="Brightness">{detail.brightness}</Descriptions.Item>
                  <Descriptions.Item label="Wifi">{<Card bodyStyle={{ padding: 0 }} bordered={false}>
                    <Descriptions
                      bordered
                      column={1}
                      size="small"
                      labelStyle={{ fontWeight: 600, width: "180px" }}
                    >
                      <Descriptions.Item label="Status">
                        {detail.wifi_status === "ON" ? (
                          <Tag color="green">ON</Tag>
                        ) : (
                          <Tag color="red">OFF</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="SSID">
                        {detail.wifi_ssid || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="IP Address">
                        {detail.wifi_ip_address || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="IPv6 Address">
                        {detail.wifi_ipv6_address || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="MAC Address">
                        <Text code>{detail.wifi_mac_address || "N/A"}</Text>
                      </Descriptions.Item>
                      <Descriptions.Item label="Signal Strength">
                        {detail.wifi_signal_strength
                          ? `${detail.wifi_signal_strength}`
                          : "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>}</Descriptions.Item>
                  <Descriptions.Item label="Ethernet">{<Card bodyStyle={{ padding: 0 }} bordered={false}>
                    <Descriptions
                      bordered
                      column={1}
                      size="small"
                      labelStyle={{ fontWeight: 600, width: "180px" }}
                    >
                      <Descriptions.Item label="Cable">
                        {detail.ethernet_cable === "ATTACHED" ? (
                          <Tag color="green">ATTACHED</Tag>
                        ) : (
                          <Tag color="red">DETACHED</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="Status">
                        {detail.ethernet_status === "CONNECTED" ? (
                          <Tag color="green">CONNECTED</Tag>
                        ) : (
                          <Tag color="red">DISCONNECTED</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="IP Address">
                        {detail.ethernet_ip_address || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="IPv6 Address">
                        {detail.ethernet_ipv6_address || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="MAC Address">
                        <Text code>{detail.ethernet_mac_address || "N/A"}</Text>
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>}</Descriptions.Item>
                  <Descriptions.Item label="Orientation">{detail.orientation}</Descriptions.Item>
                  {detail && (
                    <Descriptions.Item label="Force Orientation">
                      <Radio.Group
                        onChange={handleForceOrientationChange}
                        value={isForceOrientation}
                      >
                        <Radio value="yes">Yes</Radio>
                        <Radio value="no">No</Radio>
                      </Radio.Group>
                      <br></br>
                      {isForceOrientation === "yes" && (
                        <Select
                          placeholder="Select Orientation Position"
                          style={{ marginTop: 8, minWidth: 200 }}
                          value={obj[isForceOrientationPosition]}
                          onChange={handleForceOrientationPositionChange}
                        >
                          <Option value="0">Landscape Primary</Option>
                          <Option value="90">Portrait Primary</Option>
                          <Option value="180">Landscape Secondary</Option>
                          <Option value="270">Portrait Secondary</Option>
                        </Select>
                      )}
                    </Descriptions.Item>
                  )}

                  <Descriptions.Item label="Auto Rotation">{detail.is_auto_rotation === "1" ? <Tag color="green">Enable</Tag> : <Tag color="red">Disable</Tag>}</Descriptions.Item>
                  <Descriptions.Item label="Device Location">
                    <>
                      <span>
                        {detail.device_location_source}
                      </span>
                      <Button size="small" onClick={() => handleOpenMap(detail.device_lat, detail.device_lng)} style={{ border: "none", backgroundColor: "transparent", boxShadow: "none", color: "blue", position: "relative", top: "2px", left: "5px" }}>
                        <img src="https://icons.veryicon.com/png/o/photographic/ant-design-official-icon-library/location-37.png" alt="Device Location" style={{ width: "15px", height: "15px" }} />
                      </Button>
                    </>
                  </Descriptions.Item>
                  <Descriptions.Item label="Device Time">{detail.device_time}</Descriptions.Item>
                  <Descriptions.Item label="Screen">{screens.find((screen) => screen.id === detail.screen_id)?.name}</Descriptions.Item>
                  <Descriptions.Item label="Playlist">{playlists.find((playlist) => playlist.id === detail.playlist_id)?.title}</Descriptions.Item>
                  <Descriptions.Item label="Connection Status">{detail.screen_connection_status.charAt(0).toUpperCase() + detail.screen_connection_status.slice(1)}</Descriptions.Item>
                  <Descriptions.Item label="Last Connected">{detail.last_connected_at}</Descriptions.Item>
                  <Descriptions.Item label="Last Disconnected">{detail.last_disconnected_at}</Descriptions.Item>
                  <Descriptions.Item label="Status">{detail.status.charAt(0).toUpperCase() + detail.status.slice(1)}</Descriptions.Item>
                  <Descriptions.Item label="Created At">{detail.created_at}</Descriptions.Item>
                  <Descriptions.Item label="Updated At">{detail.updated_at}</Descriptions.Item>
                </Descriptions>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    // disable if no selection
                    ((isForceOrientation === "yes" && isForceOrientationPosition === null)) ||
                    // disable if nothing changed
                    (((detail.is_force_orientation === null) || isForceOrientation === detail.is_force_orientation &&
                      isForceOrientationPosition === detail.force_orientation_position))
                  }
                >
                  Submit
                </Button>
              </form>
            )
          }
        </Modal>
        <Modal
          title={
            <Space>
              <span style={{ fontWeight: 600 }}>Device Logs</span>
              <Tag color="blue">
                ID:
                {selectedDeviceId &&
                  devices.find((device) => device.id === selectedDeviceId)?.uuid.toString()}
              </Tag>
            </Space>
          }
          onCancel={() => {
            setLogsModalOpen(false);
            setSelectedDeviceId(null);
            setEventFilter(null);
            setDateRange([]);
            setLogCurrentPage(1);
            setLogPageSize(10);
            setLogs([]);
            setTotalLogRecords(0);
          }}
          open={logsModalOpen}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
          footer={null}
        >
          <Space style={{ marginBottom: 16, display: "flex", justifyContent: "space-between" }}>
            <RangePicker
              value={dateRange}
              onChange={(dates) => setDateRange(dates || [])}
            />
            <Select
              placeholder="Filter by Event"
              value={eventFilter}
              style={{ width: 150 }}
              allowClear
              onChange={(value) => setEventFilter(value)}
            >
              <Option value="connected">Connected</Option>
              <Option value="init">Init</Option>
              <Option value="disconnected">Disconnected</Option>
            </Select>
            <Button type="primary" onClick={() => { setLogCurrentPage(1); fetchLogs(selectedDeviceId, 1, logPageSize) }}>
              Apply Filters
            </Button>
          </Space>

          <Table
            loading={loading}
            columns={columnLogs}
            dataSource={logs}
            scroll={{ x: "max-content" }}
            rowKey={(record) => record.id}
            onChange={handleLogTableChange}
            pagination={{
              current: logCurrentPage,
              pageSize: logPageSize,
              total: totalLogRecords,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} logs`,
              showSizeChanger: true, // Enables the page size selection dropdown
              pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
            }}
          />
        </Modal>
      </div>
    </RequirePermission>
  );
};

export default Devices;
